import { toast } from "./toast";

/**
 * UI-only gate for public signup navigation.
 * Backend POST /api/auth/register remains enabled regardless of this flag.
 *
 * Re-enable public signup: REACT_APP_ALLOW_PUBLIC_REGISTRATION=true
 * (legacy alias: REACT_APP_ALLOW_SELF_REGISTRATION=true)
 * Local dev builds also enable signup when NODE_ENV=development.
 */
export const PUBLIC_REGISTRATION_ENABLED =
  process.env.REACT_APP_ALLOW_PUBLIC_REGISTRATION === "true" ||
  process.env.REACT_APP_ALLOW_SELF_REGISTRATION === "true" ||
  process.env.NODE_ENV === "development";

/** @deprecated Use PUBLIC_REGISTRATION_ENABLED */
export const SELF_REGISTRATION_ENABLED = PUBLIC_REGISTRATION_ENABLED;

export const SELF_REGISTRATION_DISABLED_MESSAGE =
  "Self-registration is currently disabled.\n\nPlease contact our Sales Team to register your organization or request a product demo.";

export function showSelfRegistrationDisabledToast() {
  toast.info("Self-registration is currently disabled.", {
    description:
      "Please contact our Sales Team to register your organization or request a product demo.",
    duration: 8000,
  });
}
